import axios from 'axios';
const loadSprite = {
  svg: document.getElementById('svg') as HTMLElement,

  init() {  
    this.load();
  },

  async load() {
    let svg = this.svg.dataset.url as string;
    let res = await axios.get(svg);
    let html = res.data;
    this.svg.innerHTML = html;
  },


}

export default loadSprite;